export default __webpack_public_path__ + "media/images/cta_blocks/invite_your_partner-561cbf7305c353d10a771cdee6b0cb40.jpg";